var f = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var p = (t, i, s) => i in t ? f(t, i, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[i] = s, l = (t, i) => {
  for (var s in i || (i = {}))
    d.call(i, s) && p(t, s, i[s]);
  if (o)
    for (var s of o(i))
      c.call(i, s) && p(t, s, i[s]);
  return t;
};
var a = (t, i) => {
  var s = {};
  for (var e in t)
    d.call(t, e) && i.indexOf(e) < 0 && (s[e] = t[e]);
  if (t != null && o)
    for (var e of o(t))
      i.indexOf(e) < 0 && c.call(t, e) && (s[e] = t[e]);
  return s;
};
import { i as u, C as h } from "./compressor.esm-9dfde4b1.js";
import { u as xi } from "./compressor.esm-9dfde4b1.js";
import { useState as _, useCallback as g } from "react";
const gi = () => {
  const [, t] = _();
  return {
    throwError: g((s) => {
      t(() => {
        throw u(s) ? new Error() : s;
      });
    }, [])
  };
};
function m(t) {
  const r = t, { fieldId: i, craneId: s } = r, e = a(r, ["fieldId", "craneId"]);
  return this.axios.post(
    `/api/private/fields/${i}/gate_passages/crane_uses/${s}`,
    e
  );
}
function v(t) {
  const { id: i } = t;
  return this.axios.patch("/api/private/users/agreed_terms", { id: i });
}
function I(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/works/list_for_all_partner_company`,
    { params: s }
  );
}
function $(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_trees/can_operate_multiple`,
    {
      params: s
    }
  );
}
function x(t) {
  const r = t, { fieldId: i, workId: s } = r, e = a(r, ["fieldId", "workId"]);
  return this.axios.get(
    `/api/private/fields/${i}/works/${s}/check_before_deleting_work`,
    { params: e }
  );
}
function y(t) {
  const i = a(t, []);
  return this.axios.get(
    "/api/private/login_user_groups/duplicate_email_check",
    { params: i }
  );
}
function k(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/check_in_out_logs/field_tree_worker_logs`,
    { params: s }
  );
}
function w(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/login_user_groups/integrate_check", {
    params: i
  });
}
function L(t) {
  const e = t, { companyBranchId: i } = e, s = a(e, ["companyBranchId"]);
  return this.axios.get(
    `/api/private/company_branches/${i}/company_item_orders/list`,
    { params: s }
  );
}
function U(t) {
  const e = t, { companyBranchId: i } = e, s = a(e, ["companyBranchId"]);
  return this.axios.get(
    `/api/private/company_branches/${i}/company_item_settings/list`,
    { params: s }
  );
}
function S(t) {
  const i = a(t, []);
  return this.axios.get(
    "/api/private/construction_placement_places/place_list",
    { params: i }
  );
}
function C(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/works/count_reflect_work`,
    { params: s }
  );
}
function b(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(
    `/api/private/fields/${i}/crane_operator_schedules`,
    s
  );
}
function D(t) {
  const { fieldId: i, craneOperatorId: s } = t;
  return this.axios.delete(
    `/api/private/fields/${i}/crane_operator_schedules/${s}`
  );
}
function F(t) {
  const r = t, { fieldId: i, craneOperatorId: s } = r, e = a(r, ["fieldId", "craneOperatorId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/crane_operator_schedules/${s}`,
    e
  );
}
function P(t) {
  const r = t, { fieldId: i, craneId: s } = r, e = a(r, ["fieldId", "craneId"]);
  return this.axios.get(`/api/private/fields/${i}/cranes/${s}`, {
    params: e
  });
}
function T(t) {
  const { fieldId: i, ids: s } = t;
  return this.axios.patch(
    `/api/private/fields/${i}/crane_uses/approval_update`,
    { ids: s }
  );
}
function O(t) {
  const { fieldId: i, ids: s, use_date: e } = t;
  return this.axios.post(`/api/private/fields/${i}/crane_uses/copy`, {
    ids: s,
    use_date: e
  });
}
function W(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(`/api/private/fields/${i}/crane_uses`, s);
}
function A(t) {
  const r = t, { fieldId: i, craneId: s } = r, e = a(r, ["fieldId", "craneId"]);
  return this.axios.delete(
    `/api/private/fields/${i}/crane_uses/${s}`,
    { data: e }
  );
}
function B(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/crane_uses/list`, {
    params: s
  });
}
function G(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/crane_uses/list_total`,
    { params: s }
  );
}
function R(t) {
  const { fieldId: i, ids: s } = t;
  return this.axios.patch(
    `/api/private/fields/${i}/crane_uses/release_approval_update`,
    { ids: s }
  );
}
function E(t) {
  const r = t, { fieldId: i, craneId: s } = r, e = a(r, ["fieldId", "craneId"]);
  return this.axios.get(
    `/api/private/fields/${i}/crane_uses/${s}`,
    { params: e }
  );
}
function H(t) {
  const r = t, { fieldId: i, craneId: s } = r, e = a(r, ["fieldId", "craneId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/crane_uses/${s}`,
    e
  );
}
function M(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/cranes/list`, {
    params: s
  });
}
function j(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/cranes/list_for_crane_uses`,
    { params: s }
  );
}
function z(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_groups/list_for_search`,
    { params: s }
  );
}
function J(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_item_lists/list`,
    { params: s }
  );
}
function K(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/current_prime_contractors_company_branch_id`,
    { params: s }
  );
}
function V(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.delete(
    `/api/private/fields/${i}/check_in_out_logs/destroy_list`,
    { data: s }
  );
}
function q(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.delete(
    `/api/private/fields/${i}/work_approvals/destroy`,
    { data: s }
  );
}
function N(t) {
  const n = t, { fieldId: i, workerId: s, fieldTreeWorkerId: e } = n, r = a(n, ["fieldId", "workerId", "fieldTreeWorkerId"]);
  return this.axios.get(
    `/api/private/fields/${i}/workers/${s}/assigned_field_tree_worker/${e}`,
    {
      params: r
    }
  );
}
function Q(t) {
  const r = t, { fieldId: i, workerId: s } = r, e = a(r, ["fieldId", "workerId"]);
  return this.axios.get(
    `/api/private/fields/${i}/workers/${s}/assigned_field_tree_workers`,
    {
      params: e
    }
  );
}
function X(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/check_in_out_settings`,
    {
      params: s
    }
  );
}
function Y(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/company_user_invitation_statuses", {
    params: i
  });
}
function Z(t) {
  const e = t, { companyId: i } = e, s = a(e, ["companyId"]);
  return this.axios.get(
    `/api/private/companies/${i}/company_user_permission`,
    { params: s }
  );
}
function ee(t) {
  const e = t, { companyId: i } = e, s = a(e, ["companyId"]);
  return this.axios.get(
    `/api/private/companies/${i}/company_user_permissions/list`,
    { params: s }
  );
}
function te(t) {
  const { fieldId: i } = t;
  return this.axios.get(
    `/api/private/fields/${i}/works/unapproved_count`
  );
}
function ie(t) {
  const e = t, { companyId: i } = e, s = a(e, ["companyId"]);
  return this.axios.get(
    `/api/private/companies/${i}/partner_company_branches`,
    { params: s }
  );
}
function se(t) {
  const r = t, { fieldId: i, fieldTreeWorkerId: s } = r, e = a(r, ["fieldId", "fieldTreeWorkerId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_tree_workers/${s}/worker_info`,
    {
      params: e
    }
  );
}
function ae(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_bulletin_boards/list`,
    { params: s }
  );
}
function re(t) {
  const { fieldId: i, id: s } = t;
  return this.axios.get(
    `/api/private/fields/${i}/field_bulletin_boards/${s}`
  );
}
function ne(t) {
  const { fieldId: i, id: s } = t;
  return this.axios.post(
    `/api/private/fields/${i}/field_bulletin_boards/${s}/read`
  );
}
function oe(t) {
  const { fieldId: i, id: s, documentId: e } = t;
  return this.axios.get(
    `/api/private/fields/${i}/field_bulletin_boards/${s}/field_bulletin_board_documents/${e}/presigned_url`
  );
}
function pe(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/check_accessible`, {
    params: s
  });
}
function de(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_images/guidemap`,
    { params: s }
  );
}
function ce(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_images/image_list`,
    { params: s }
  );
}
function le(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/field_item`, {
    params: s
  });
}
function fe(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_trees/tree_company_branches`,
    { params: s }
  );
}
function ue(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/jv_company_list`, {
    params: s
  });
}
function he(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_trees/list_for_check_in_out_logs`,
    {
      params: s
    }
  );
}
function _e(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_trees/list_for_worker_settings`,
    {
      params: s
    }
  );
}
function ge(t) {
  const r = t, { fieldId: i, fieldTreeId: s } = r, e = a(r, ["fieldId", "fieldTreeId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_trees/${s}/tree_users`,
    { params: e }
  );
}
function me(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/fields/list", { params: i });
}
function ve(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}`, { params: s });
}
function Ie(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/gates/list_for_gate_passages`,
    { params: s }
  );
}
function $e(t) {
  const { fieldId: i, ids: s, passage_date: e } = t;
  return this.axios.post(`/api/private/fields/${i}/gate_passages/copy`, {
    ids: s,
    passage_date: e
  });
}
function xe(t) {
  const { fieldId: i, work_hour_zone: s, date: e } = t;
  return this.axios.get(
    `/api/private/fields/${i}/gate_passages/latest_registration`,
    { params: { work_hour_zone: s, date: e } }
  );
}
function ye(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${t.fieldId}/gate_passages/list`,
    { params: s }
  );
}
function ke(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/gate_passages/list_total`,
    { params: s }
  );
}
function we(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/gate_passages/list`,
    s
  );
}
function Le(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/gate_passages/registration_history_list`,
    { params: s }
  );
}
function Ue(t) {
  const r = t, { fieldId: i, gateId: s } = r, e = a(r, ["fieldId", "gateId"]);
  return this.axios.get(
    `/api/private/fields/${i}/gate_passages/${s}`,
    { params: e }
  );
}
function Se(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(`/api/private/fields/${i}/gate_passages`, s);
}
function Ce(t) {
  const r = t, { fieldId: i, gateId: s } = r, e = a(r, ["fieldId", "gateId"]);
  return this.axios.delete(
    `/api/private/fields/${i}/gate_passages/${s}`,
    { data: e }
  );
}
function be(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/gates`, { params: s });
}
function De(t) {
  const r = t, { fieldId: i, gateId: s } = r, e = a(r, ["fieldId", "gateId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/gate_passages/${s}`,
    e
  );
}
function Fe(t) {
  const { fieldId: i } = t;
  return this.axios.get(
    `/api/private/fields/${i}/crane_uses/spot_history_list`
  );
}
function Pe(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/direct_talkrooms/list", { params: i });
}
function Te(t) {
  const i = a(t, []);
  return this.axios.get(
    "/api/private/external_service_cooperation_status/list",
    {
      params: i
    }
  );
}
function Oe(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_contractor_users/list`,
    { params: s }
  );
}
function We(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_groups/list_for_search`,
    { params: s }
  );
}
function Ae(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_item_lists/list`,
    { params: s }
  );
}
function Be(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/spt/fields/${i}/spt_field_work_types/list`,
    { params: s }
  );
}
function Ge(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/progress/fields/${i}/field_main_work_types`,
    { params: s }
  );
}
function Re(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/progress/fields/${i}/field_sub_work_types`,
    { params: s }
  );
}
function Ee(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/gate_passages/transportation_groups`,
    { params: s }
  );
}
function He(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fleet_mgmt/fields/${i}/gate_fleet_system_routes`,
    { params: s }
  );
}
function Me(t) {
  const { fieldId: i } = t;
  return this.axios.get(
    `/api/private/fields/${i}/gate_passages/spot_history_list`
  );
}
function je(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/works/history_spt`, {
    params: s
  });
}
function ze(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/lw_talkrooms/list`, {
    params: s
  });
}
function Je(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/progress/fields/${i}/progress_field_settings`,
    { params: s }
  );
}
function Ke(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/spt/fields/${i}/spt_linkage_setting`,
    {
      params: s
    }
  );
}
function Ve() {
  return this.axios.get("/api/private/user_profiles");
}
function qe(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/crane_uses/latest_registration`,
    { params: s }
  );
}
function Ne(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/machinery_uses/latest_registration`,
    { params: s }
  );
}
function Qe(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/works/show_latest_schedule`,
    { params: s }
  );
}
function Xe(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/works/list_unreflect_works`,
    { params: s }
  );
}
function Ye(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/manual_managements/list", {
    params: i
  });
}
function Ze(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/company_branches/prime_list", { params: i });
}
function et(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/login_user_groups", { params: i });
}
function tt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/work_dates`, {
    params: s
  });
}
function it(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/machineries/list`, {
    params: s
  });
}
function st(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/machineries/list_for_machinery_uses`,
    { params: s }
  );
}
function at(t) {
  const r = t, { fieldId: i, machineId: s } = r, e = a(r, ["fieldId", "machineId"]);
  return this.axios.get(
    `/api/private/fields/${i}/machineries/${s}`,
    {
      params: e
    }
  );
}
function rt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/machineries/list`, {
    params: s
  });
}
function nt(t) {
  const { fieldId: i, ids: s } = t;
  return this.axios.patch(
    `/api/private/fields/${i}/machinery_uses/approval_update`,
    { ids: s }
  );
}
function ot(t) {
  const { fieldId: i, ids: s, use_date: e } = t;
  return this.axios.post(`/api/private/fields/${i}/machinery_uses/copy`, {
    ids: s,
    use_date: e
  });
}
function pt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(`/api/private/fields/${i}/machinery_uses`, s);
}
function dt(t) {
  const r = t, { fieldId: i, machineId: s } = r, e = a(r, ["fieldId", "machineId"]);
  return this.axios.delete(
    `/api/private/fields/${i}/machinery_uses/${s}`,
    {
      data: e
    }
  );
}
function ct(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/machinery_uses/list`, {
    params: s
  });
}
function lt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/machinery_uses/list_total`,
    {
      params: s
    }
  );
}
function ft(t) {
  const { fieldId: i, ids: s } = t;
  return this.axios.patch(
    `/api/private/fields/${i}/machinery_uses/release_approval_update`,
    { ids: s }
  );
}
function ut(t) {
  const r = t, { fieldId: i, machineId: s } = r, e = a(r, ["fieldId", "machineId"]);
  return this.axios.get(
    `/api/private/fields/${i}/machinery_uses/${s}`,
    {
      params: e
    }
  );
}
function ht(t) {
  const r = t, { fieldId: i, machineryId: s } = r, e = a(r, ["fieldId", "machineryId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/machinery_uses/${s}`,
    e
  );
}
function _t(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/notices/system_lists", {
    params: i
  });
}
function gt(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/notices/list", { params: i });
}
function mt(t) {
  const i = a(t, []);
  return this.axios.get("/api/private/users/password_policies", { params: i });
}
function vt(t) {
  const { id: i } = t;
  return this.axios.get(`/api/private/manual_managements/download?id=${i}`, {
    responseType: "blob"
  });
}
function It(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/work_dates/recent_work_date`,
    { params: s }
  );
}
function $t(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(
    `/api/private/fields/${i}/check_in_out_logs`,
    s
  );
}
function xt(t) {
  const i = a(t, []);
  return this.axios.post("/api/private/notices/register_unentered", { data: i });
}
function yt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/crane_uses/registration_history_list`,
    { params: s }
  );
}
function kt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/machinery_uses/registration_history_list`,
    { params: s }
  );
}
function wt(t) {
  const r = t, { fieldId: i, safetyDiaryId: s } = r, e = a(r, ["fieldId", "safetyDiaryId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/safety_diaries/${s}/approval`,
    e
  );
}
function Lt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(`/api/private/fields/${i}/safety_diaries`, s);
}
function Ut(t) {
  const r = t, { fieldId: i, safetyDiaryId: s } = r, e = a(r, ["fieldId", "safetyDiaryId"]);
  return this.axios.delete(
    `/api/private/fields/${i}/safety_diaries/${s}`,
    {
      data: e
    }
  );
}
function St(t) {
  const r = t, { fieldId: i, safetyDiaryId: s } = r, e = a(r, ["fieldId", "safetyDiaryId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/safety_diaries/${s}/report`,
    e
  );
}
function Ct(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/safety_diaries/search_list`,
    { params: s }
  );
}
function bt(t) {
  const r = t, { fieldId: i, safetyDiaryId: s } = r, e = a(r, ["fieldId", "safetyDiaryId"]);
  return this.axios.get(
    `/api/private/fields/${i}/safety_diaries/${s}`,
    {
      params: e
    }
  );
}
function Dt(t) {
  const r = t, { fieldId: i, safetyDiaryId: s } = r, e = a(r, ["fieldId", "safetyDiaryId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/safety_diaries/${s}`,
    e
  );
}
function Ft(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/field_trees/selectable_companies_list`,
    { params: s }
  );
}
function Pt(t) {
  const { fieldId: i } = t;
  return this.axios.get(
    `/api/private/fields/${i}/machinery_uses/spot_history_list`
  );
}
function Tt(t) {
  const { fileCode: i } = t;
  return this.axios.get(
    `/api/private/static_files/preview?file_code=${i}`,
    {
      responseType: "blob"
    }
  );
}
function Ot(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/works/histories`, {
    params: s
  });
}
function Wt(t) {
  const { field_id: i, field_tree_id: s } = t;
  return this.axios.get(
    `/api/private/fields/${i}/field_trees/${s}/tree_jobs`,
    { params: t }
  );
}
function At(t) {
  const r = t, { fieldId: i, checkInOutLogId: s } = r, e = a(r, ["fieldId", "checkInOutLogId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/check_in_out_logs/${s}`,
    e
  );
}
function Bt(t) {
  const e = t, { id: i } = e, s = a(e, ["id"]);
  return this.axios.patch(
    `/api/private/company_user_invitation_statuses/${i}`,
    s
  );
}
function Gt(t) {
  const i = a(t, []);
  return this.axios.patch("/api/private/sessions", i);
}
function Rt(t) {
  const i = a(t, []);
  return this.axios.post("/api/private/login_user_groups/update_user", {
    data: i
  });
}
function Et(t) {
  const e = t, { partner_company_id: i } = e, s = a(e, ["partner_company_id"]);
  return this.axios.patch("/api/private/sessions/update_partner", l({
    partner_company_id: i
  }, s));
}
function Ht(t) {
  const r = t, { userId: i } = r, s = a(r, ["userId"]), e = new FormData();
  for (const n in s)
    e.append(n, s[n]);
  return this.axios.patch(`/api/private/users/update_full/${i}`, e);
}
function Mt(t) {
  const e = t, { userId: i } = e, s = a(e, ["userId"]);
  return this.axios.patch(
    `/api/private/users/update_full_integrate/${i}`,
    {
      data: s
    }
  );
}
function jt(t) {
  const e = t, { userId: i } = e, s = a(e, ["userId"]);
  return this.axios.get(`/api/private/user_profiles/${i}`, { params: s });
}
function zt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(
    `/api/private/fields/${i}/work_approvals/create_list`,
    s
  );
}
function Jt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.delete(
    `/api/private/fields/${i}/work_approvals/destroy_list`,
    { data: s }
  );
}
function Kt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/work_approvals/list`, {
    params: s
  });
}
function Vt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/worker_settings/sp_list`,
    { params: s }
  );
}
function qt(t) {
  const { params: i } = t, s = new FormData();
  for (const e in i)
    s.append(e, i[e]);
  return this.axios.post(
    "/api/private/ccus/workers/face_image_upload",
    s,
    {
      headers: { "content-type": "multipart/form-data" }
    }
  );
}
function Nt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/works/group_id_list`, {
    params: s
  });
}
function Qt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/field_images/keyplan`, {
    params: s
  });
}
function Xt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/works/work_key_plan_image`,
    {
      params: s
    }
  );
}
function Yt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(
    `/api/private/fields/${i}/work_partner_company_approvals`,
    s
  );
}
function Zt(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.delete(
    `/api/private/fields/${i}/work_partner_company_approvals`,
    { data: s }
  );
}
function ei(t) {
  const r = t, { fieldId: i, workId: s } = r, e = a(r, ["fieldId", "workId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/works/${s}/abort`,
    {
      data: e
    }
  );
}
function ti(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(`/api/private/fields/${i}/works`, s);
}
function ii(t) {
  const r = t, { fieldId: i, workId: s } = r, e = a(r, ["fieldId", "workId"]);
  return this.axios.delete(`/api/private/fields/${i}/works/${s}`, {
    data: e
  });
}
function si(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(
    `/api/private/fields/${i}/works/group_sum_man_hours`,
    {
      params: s
    }
  );
}
function ai(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/works/list`, {
    params: s
  });
}
function ri(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.get(`/api/private/fields/${i}/works/list_total`, {
    params: s
  });
}
function ni(t) {
  const r = t, { fieldId: i, workId: s } = r, e = a(r, ["fieldId", "workId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/works/${s}/resume`,
    {
      data: e
    }
  );
}
function oi(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(
    `/api/private/fields/${i}/works/copy_works`,
    s
  );
}
function pi(t) {
  const e = t, { fieldId: i } = e, s = a(e, ["fieldId"]);
  return this.axios.post(
    `/api/private/fields/${i}/works/schedules_reflect_on_histories`,
    s
  );
}
function di(t) {
  const r = t, { fieldId: i, workId: s } = r, e = a(r, ["fieldId", "workId"]);
  return this.axios.get(`/api/private/fields/${i}/works/${s}`, {
    params: e
  });
}
function ci(t) {
  const r = t, { fieldId: i, workId: s } = r, e = a(r, ["fieldId", "workId"]);
  return this.axios.patch(
    `/api/private/fields/${i}/works/${s}`,
    e
  );
}
function li(t) {
  const { fieldId: i } = t;
  return this.axios.get(`/api/private/fields/${i}/field_urls`);
}
const fi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addCraneUse: m,
  agreeTerms: v,
  allPartnerCompanyList: I,
  canOperateMultiple: $,
  checkBeforeDeletingWork: x,
  checkDuplicateEmail: y,
  checkInOutLogsFieldTreeWorkerLogs: k,
  checkIntegrate: w,
  companyItemOrders: L,
  companyItemSettings: U,
  constructionPlacementPlacesPlaceList: S,
  countReflectWork: C,
  craneOperatorSchedulesCreate: b,
  craneOperatorSchedulesDelete: D,
  craneOperatorSchedulesUpdate: F,
  craneShow: P,
  craneUsesApprovalUpdate: T,
  craneUsesCopy: O,
  craneUsesCreate: W,
  craneUsesDestroy: A,
  craneUsesList: B,
  craneUsesListTotal: G,
  craneUsesReleaseApprovalUpdate: R,
  craneUsesShow: E,
  craneUsesUpdate: H,
  cranesList: M,
  cranesListForCraneUses: j,
  createFieldGroupsOptionSelectBox: z,
  createFieldItemOptionSelectBox: J,
  currentPrimeContractor: K,
  deleteCheckInOutLogs: V,
  destroyApprovals: q,
  downloadFile: oe,
  fetchAssignedFieldTreeWorker: N,
  fetchAssignedFieldTreeWorkersList: Q,
  fetchCheckInOutSettings: X,
  fetchCompanyUserInvitationStatus: Y,
  fetchCompanyUserPermission: Z,
  fetchCompanyUserPermissions: ee,
  fetchFieldBulletinBoard: re,
  fetchFieldBulletinBoardList: ae,
  fetchGroupWorkCount: te,
  fetchPartnerCompanyBranches: ie,
  fetchWorkerInfo: se,
  fieldCheckUserAccessible: pe,
  fieldGuideMap: de,
  fieldImagesList: ce,
  fieldItems: le,
  fieldTreeCompanyBranches: fe,
  fieldTreeJVCompanyBranches: ue,
  fieldTreesListForCheckInOutLogs: he,
  fieldTreesListForWorkerSettings: _e,
  fieldTreesUsersList: ge,
  fieldUrls: li,
  fieldsList: me,
  fieldsShow: ve,
  gateListForGatePassages: Ie,
  gatePassagesCopy: $e,
  gatePassagesLatestRegistration: xe,
  gatePassagesList: ye,
  gatePassagesListTotal: ke,
  gatePassagesListUpdate: we,
  gatePassagesRegistrationHistoryList: Le,
  gatePassagesShow: Ue,
  gatesCreate: Se,
  gatesDestroy: Ce,
  gatesList: be,
  gatesUpdate: De,
  getCraneUsesSpotHistoryList: Fe,
  getDirectTalkrooms: Pe,
  getExternalServiceCooperationStatus: Te,
  getFieldContractorUsersList: Oe,
  getFieldGroupsListForSearch: We,
  getFieldItemList: Ae,
  getFieldSptWorkType: Be,
  getFieldTransportationGroups: Ee,
  getFieldsMainWork: Ge,
  getFieldsSubWork: Re,
  getGateFleetSysRoutes: He,
  getGatePassagesSpotHistoryList: Me,
  getHistorySpt: je,
  getLwTalkrooms: ze,
  getProgressFieldSettings: Je,
  getSptLinkageSetting: Ke,
  getUserProfiles: Ve,
  latestCraneUses: qe,
  latestMachineryUses: Ne,
  latestWorkShow: Qe,
  listUnreflectWorks: Xe,
  loadManualManagementsList: Ye,
  loadPrimeList: Ze,
  loadUserIntegrateList: et,
  loadWorkDateList: tt,
  machineriesList: it,
  machineriesListForMachineryUses: st,
  machineryShow: at,
  machineryShowList: rt,
  machineryUsesApprovalUpdate: nt,
  machineryUsesCopy: ot,
  machineryUsesCreate: pt,
  machineryUsesDestroy: dt,
  machineryUsesList: ct,
  machineryUsesListTotal: lt,
  machineryUsesReleaseApprovalUpdate: ft,
  machineryUsesShow: ut,
  machineryUsesUpdate: ht,
  noticesSystemList: _t,
  notificationsList: gt,
  passwordPolicy: mt,
  pdfDownloads: vt,
  recentWorkDate: It,
  registerAlreadyRead: ne,
  registerCheckInOutLogs: $t,
  registerUnentered: xt,
  registrationHistoryList: yt,
  registrationMachineryHistoryList: kt,
  safetyDiariesApproval: wt,
  safetyDiariesCreate: Lt,
  safetyDiariesDestroy: Ut,
  safetyDiariesReport: St,
  safetyDiariesSearchList: Ct,
  safetyDiariesShow: bt,
  safetyDiariesUpdate: Dt,
  selectableCompaniesList: Ft,
  spotHistoryMachineryList: Pt,
  staticFilesDownload: Tt,
  treeHistory: Ot,
  treeJobsList: Wt,
  updateCheckInOutLogs: At,
  updateCompanyUserInvitationStatus: Bt,
  updateField: Gt,
  updateLoginGroupUser: Rt,
  updatePartner: Et,
  userEdit: Ht,
  userEditIntegrate: Mt,
  userProfilesShow: jt,
  workApprovalsCreateList: zt,
  workApprovalsDestroyList: Jt,
  workApprovalsList: Kt,
  workGroupIdList: Nt,
  workKeyPlan: Qt,
  workKeyPlanImage: Xt,
  workPartnerCompanyApprovalsReceive: Yt,
  workPartnerCompanyApprovalsReceiveCancel: Zt,
  workerSettingsSpList: Vt,
  workersFaceImageUpload: qt,
  worksAbort: ei,
  worksCreate: ti,
  worksDestroy: ii,
  worksGroupSumManHours: si,
  worksList: ai,
  worksListTotal: ri,
  worksResume: ni,
  worksSchedulesCopy: oi,
  worksSchedulesReflectOnHistories: pi,
  worksShow: di,
  worksUpdate: ci
}, Symbol.toStringTag, { value: "Module" }));
function mi({ axios: t }) {
  const i = { axios: t };
  return Object.entries(fi).forEach(([s, e]) => {
    i[s] = e;
  }), i;
}
const vi = (t, i, s = { width: 1e3, height: 1e3 }) => {
  const { width: e, height: r } = s;
  return new h(t, {
    maxWidth: e,
    maxHeight: r,
    success: i
  });
};
export {
  vi as compressImage,
  mi as createApi,
  xi as useStateWithGetter,
  gi as useThrowError
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@bld/bld-libs/utils.js
// module id = 206
// module chunks = 0